export default __webpack_public_path__ + "static/media/network-transmit-receive.92b400e5.png";